// extracted by mini-css-extract-plugin
export var highlight = "styles-module--highlight--f4a40";
export var highlightDecor = "styles-module--highlightDecor--f7a82";
export var questions = "styles-module--questions--e60b1";